import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Firebase configuration - uses environment variables in production
// These are public client-side keys (not secret) but should still be configured via env vars
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBCbST-stUmANFURKlbN53gmWg4uBjktN8",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "ai-hair-app-d39a7.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "ai-hair-app-d39a7",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "ai-hair-app-d39a7.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "67716738564",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:67716738564:web:7033c4a609aecbed1c8f51",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-GCJ39CMD2V"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;
